import { Button, ButtonProps } from "@mantine/core"
import { IconLogin } from "@tabler/icons-react"
import { useTranslation } from "react-i18next"

interface Props extends ButtonProps {
  iconOnly?: boolean
  onClick?: () => void
}

export function LoginButton({ iconOnly, ...props }: Props) {
  const { t } = useTranslation("app_server")

  return (
    <Button leftSection={<IconLogin />} {...props}>
      {iconOnly ? null : t("Login")}
    </Button>
  )
}
